import { DownOutlined } from "@ant-design/icons";
import { SpotLightEnum } from "@src/pages/ab-test-explore/enum";
import { Dropdown, Space } from "antd";
import { MenuProps } from "antd/lib";
export const ReportSpotLight: React.FC<{
    reportSpotLight: SpotLightEnum;
    setReportSpotLight: React.Dispatch<React.SetStateAction<SpotLightEnum>>;
    exclude?: SpotLightEnum[];
}> = ({ setReportSpotLight, reportSpotLight, exclude }) => {
    const items: MenuProps["items"] = [
        {
            key: SpotLightEnum.PercentChange,
            label: "% Change",
            onClick: () => {
                setReportSpotLight(SpotLightEnum.PercentChange);
            },
        },
        {
            key: SpotLightEnum.Mean,
            label: "Mean",
            onClick: () => {
                setReportSpotLight(SpotLightEnum.Mean);
            },
        },
        {
            key: SpotLightEnum.AbsoluteChange,
            label: "Absolute Change",
            onClick: () => {
                setReportSpotLight(SpotLightEnum.AbsoluteChange);
            },
        },
        {
            key: SpotLightEnum.MeasureValue,
            label: "Measure Value",
            onClick: () => {
                setReportSpotLight(SpotLightEnum.MeasureValue);
            },
        },
    ];
    return (
        <Dropdown
            menu={{
                items: items.filter((item) => !exclude?.includes(item?.key as SpotLightEnum)),
                selectable: true,
                defaultSelectedKeys: [reportSpotLight],
            }}
        >
            <Space
                className="py-1 px-3 rounded-[4px] bg-white  cursor-pointer flex items-center"
                onClick={(e) => e.stopPropagation()}
            >
                <DownOutlined /> Spotlight Data
            </Space>
        </Dropdown>
    );
};
